import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";
import { EventDatabse } from "../../../../types";
import { useDeleteEvent } from "../../api/useDeleteEvent";

type Props = {
  event: EventDatabse;
  onClose: () => void;
  onDeleted?: () => void;
}

export default function DeleteEventModal(props: Props) {
  const { mutateAsync } = useDeleteEvent();

  async function handleConfirm() {
    await mutateAsync({ id: props.event.id, subTopicId: props.event.subject_id ?? '' });
    props.onDeleted?.();
  }

  return (
    <ConfirmDeleteDialog
      title="Supprimer l'événement"
      confirmLabel="Supprimer l'événement"
      onConfirm={handleConfirm}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer l'événement « {props.event.title} » ?
    </ConfirmDeleteDialog>
  );
}
